import Link from "next/link";
import environment from "../../../config/environment";
import styles from "./styles.module.scss";
interface ComponentTypes {
  title: string;
  slugCat: string;
  category: string;
}

export const Breadcrumb = ({ title, slugCat, category }: ComponentTypes) => {
  return (
    <div className={styles.breadcrumb}>
      <Link href="/" passHref>
        Finanzero
      </Link>
      <Link href={environment.basePath} passHref>
        Blog
      </Link>
      <Link href={`${environment.basePath}/category/${slugCat}`} passHref>
        {category}
      </Link>
      <p>{title}</p>
    </div>
  );
};
